export const privacyZH = `
## 隐私政策

更新日期: 2025年03月12日

深圳市远睿信息科技有限公司(以下简称“远睿”或“我们”)深知个人信息对您的重要性，并将按照法律法规规定，采取合理的技术措施来保护您的个人信息安全。**请务必仔细阅读并透彻理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您勾选同意或者实际开始使用Medcursor	App产品或服务，即表示您已充分理解并同意本政策**。如对本政策内容有任何疑问、意见或建议，您可通 过以下邮箱(support@medcursor.com) 与我们联系。
	
我们希望通过本隐私政策帮助您了解以下内容:

**一、我们如何收集您的个人数据**
	
**二、我们如何使用您的个人数据**
	
**三、我们如何委托处理、共享、转让、公开披露您的个人信息**
	
**四、我们如何保护您的个人数据**
	
**五、您的权利**
	
**六、我们如何处理儿童的个人数据**
	
**七、第三方提供商及其服务**
	
**八、您的个人数据如何在全球范围转移**
	
**九、本政策如何更新**
	
**十、如何联系我们**
	
	
### 一、我们如何收集和使用您的个人数据
		
在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括:
	
就我们产品/服务的基本功能，我们会收集您选择的服务**所必需的、特定的、明确及合法目的的信息**，并且不会以与这些目的不相符的方式进一步处理相关信息。此外，我们还会向您提供产品及/或服务的**附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果**，但并不会影响您正常使用我们产品及/或服务的基本功能。您也可以随时取消授权，取消授权后，我们将不会再继续收集或使用相应的服务。但并不会影响此前给予您授权所进行的信息收集和使用。
	
为了让您能够正常使用Medcursor App服务和顺利操作相关智能产品，我们可能收集以下信息中的一种或多种:
	
● **您提供给我们或上传的信息**(包括您的联系方式):我们会根据您选择的服务收集相应服务必要的部分个人信息。例如，若您创建帐号，您可能会提供您的手机号码、头像、昵称帐号安全设置等相关信息。如您根据功能自愿完善个人信息，您可能会提供您的第三方平台注册的公开信息(头像、昵称)、相片等信息。您在使用服务中，上传或发布内容、 财务信息、社交信息等信息。
	
● **设备或手机相关信息**:与您的设备相关的信息，例如 设备图片、设备名称、设备工作信息、设备cid、 固件 版本号、WiFi信号强度、IMEI 编号、IMSI编号、MAC地址、序列号、手机硬件或软件版本号、安卓ID、屏幕显示信息、设备输入信息、设备制造商信息和型号名称、网络运营商、连接类型、硬件使用相关信息(例如电量使用情况、设备温度)。
	
● **应用信息**:与您的应用使用相关的信息。例如应用列表、应用状态记录(下载、收藏、安装、更新、删除)、应用ID信息、SDK版本、系统更新设置等。
	
● **位置信息**(仅适用于特定服务/功能) :若您使用和位置相关的服务，您可能会提供与您的位置相关的各类信息。例如地区、国家、时区设置和语言设置。
	
● **日志信息**:与您使用某些功能、应用相关的信息。例 如Cookies和其他匿名标识符技术、IP 地址、网络请求信息、个人邮箱信息、临时消息历史、标准系统日志、错误崩溃信息。
	
● **社交媒体信息**:如果您使用第三方社交媒体账号登录，或绑定第三方账号，您可能会提供与您的社交活动相关的信息。
	
● **其他根据法律法规应当收集的信息**。
	
### 二、我们如何使用您的信息(其中可能包含个人信息)
		
● **创建您的帐号**。在通过网站或移动设备创建Medcursor App帐号时收集的个人信息用于建立用户的个人帐号和资料页。
	
● **提供设备连接服务**。收集信息(设备或SIM卡相关信 息，包括IMEI号码、IMSI号码、电话号码、设备号、设备操作系统、MAC地址、设备类别、系统和性能信息)用于手机与智能设备的连接，并实现配网及控制的功能。
	
● **提供其他服务**。服务收集的信息会用于执行该服务的功能，同时提供服务优化，例如下载、更新、注册、执行或优化与服务相关的活动。
	
● **提供信息发布功能**。如果您下载和使用Medcursor App,我们可能会收集您主动发布的信息，例如，您发布的自定义菜谱、评论等信息。
	
● **提供基于位置的服务**。在使用我们的服务时，通过获得您的授权同意，我们可能会使用位置信息以便为您提供正确版本的服务，并且基于准确的位置提供更好的用户体验，例如位置接入。
	
● **改善用户体验**。某些选择性加入功能，例如用户体验计划，允许我们分析用户如何使用手机和服务的数据，以改善用户体验，例如发送崩溃报告。
	
● **提供推送服务**。帐号和IMEI号码可能用于提供我们推送服务，以评估广告效果和发送软件更新或新产品发布的通知，包括销售和促销信息。您同意我们基于推送服务(无论是通过服务中集成的信息推送，还是电子邮件或其他方式)而使用您个人信息，并为您提供或推广我们及相关第三方的产品或服务。您可以随时通过更改“设置”来关闭这一功能。
	
● **验证用户身份**。验证用户的身份，协助用户识别并向用户提供适当的服务。
	
● **对用户提出的问题进行反馈**。您选择提供的反馈对帮助我们改进服务非常重要。为了处理您的反馈，我们可能会使用您所提供的个人信息以及您的操作记录等信息，与您联系后处理您提出的问题，并保留记录。
	
● **发送通知**。我们可能会使用您的个人信息来发送重要通知，例如我们的条款、条件和政策变更。

● **进行设备的分析以提供更好的用户体验**。我们将会进行硬件及软件的分析，以进一步提升设备的体验。
	
● **获得您的同意**。

我们可能在获得您的同意或指示后，出于其他目的分享您的信息。我们与第三方服务（如Facebook、Apple和Google）合作，为您提供无缝的注册、登录和内容分享体验。如果您选择使用这些功能，我们可能会与这些第三方服务分享有关您的信息。例如，这些服务可以接收有关您在平台上的活动信息，并根据其隐私政策，告知您在第三方服务上的联系人您的平台使用情况。如果您允许第三方服务访问您的帐户，我们将向第三方分享关于您的特定信息。根据您授权的权限，该第三方服务可能获得您的帐户信息和您提供的任何其他信息的访问权限。

通过像Facebook、Apple和Google这样的第三方平台登录时，我们仅为应用程序登录和注册目的，访问您的姓名和电子邮件信息。我们非常重视您的隐私，并且未经您明确的同意，我们不会向第三方披露您的详细信息。此外，除非您给予我们前行信号或主动使用该功能，否则我们不会将您的信息用于第三方应用程序。

以下详细说明了我们如何处理与 Google 帐户相关的数据：

**1. 数据访问和使用：**

Medcursor 使用 Google 帐户登录来验证用户身份。我们仅收集以下信息：

您的 Google 帐户提供的基本个人信息（例如您的姓名和电子邮件地址）。我们利用这些信息为您提供个性化帐户体验和简化登录程序等服务。我们向您保证，这些信息不会用于任何其他目的。

**2.数据存储：**

通过 Google 帐户获取的个人信息存储在安全服务器上。我们实施了充分的安全措施来保护您的个人数据免遭丢失、滥用、未经授权的访问或泄露。个人信息仅在提供服务所需的时间内保留。如果您决定停用您的帐户，我们将删除存储的数据。

**3.数据共享：**

除非我们得到您的明确同意，或为了履行法律义务、响应法院命令或政府要求，我们不会与第三方分享您的个人信息。

**4.用户控制：**

您可以随时通过 Google 帐户的设置来管理您的数据。如果您选择终止 Medcursor 帐户，我们将从您的帐户中删除所有相关信息。

### 三、我们如何委托处理、共享、转让、公开披露您的个人信息
		
1. **委托处理**
本业务功能中某些技术，模块或功能可能由外部供应商提供。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
	
2. **共享**
除法律同意的形式外，我们不会将任何个人信息出售给第三方。但我们有时可能会向第三方披露您的个人信息，包括但不限于本部分列出的第三方、关联公司。
	
● **关联公司**:为了本隐私政策中所述的目的，我们会根据向您提供产品或服务的全部功能，不时向其他的我们的关联公司披露您的个人信息。
	
● **第三方服务商**:在某些情况下，第三方可能会通过我们的服务(单独或与我们共同)向您提供服务。例如:收集用户反馈信息、分析数据、提供营销帮助、提供搜索结果和链接以及提供其他客户服务。他们可以访问执行其功能所需的个人信息，但不得将其用于其他目的。我们只会在与此类交易或服务有关的范围内，才向第三方披露您的个人信息。
	
3. **转让**。我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外:
	
● 在获取**明确同意**的情况下转让:获得您的明确同意后，我们会向其他方转让您的个人信息;
	
● 在涉及**合并、收购或破产清算**时，如涉及到个人信息转让，**我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意**。
	
4. **披露**
我们仅会在以下情形下，披露您的个人信息;
	
● **获得您明确同意后**;
	
● **基于法律的披露**: 在法律法规规定下，为履行审计义务以及满足监管要求，或经法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会披露或公开披露您的个人信息。该等情况下，我们可能不会征求您的同意。
	
### 四、我们如何保护保护您的个人数据

为保障您的个人信息安全，防止未经授权的访问、泄露或其他类似风险，我们制定了合理的管理措施。

例如，您的个人信息被储存在安全的服务器上，并在受控设施中受到保护。同样，我们对以数据存储设有专门的访问控制措施。我们定期审查信息收集、储存和处理实践，包括物理安全措施，以防止任何未经授权的访问和使用。
	
我们承诺采取合理的技术措施和管理措施来保障个人信息安全，但是，由于技术的快速发展，和互联网的复杂度，您应当意识到互联网的使用并不总是安全的，因此，我们不能保证在通过网络传输时任何个人信息的安全性、准确性和完整性。
	
如发生个人数据的泄露，我们将按照法律法规的规定及时通知相关的监管机构，及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您。
	
### 五、您的权利

1. **更正您的个人信息**: 当您发现我们处理的关于您的个人信息有错误时，您可以在“设置”页面进行更正。
	
2. **删除您的个人信息**
	
在以下情形中，您可以向我们通过电子邮件提出删除个人信息的请求:
	
(1) 如果我们处理个人信息的行为违反法律法规;
	
(2) 如果我们收集、使用您的个人信息，却未征得您的同意;
	
(3) 如果我们处理个人信息的行为违反了与您的约定;
	
(4) 如果您不再使用我们的产品或服务，或您注销了账号;
	
(5) 如果我们不再为您提供产品或服务。
	
若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。

当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
	
3. **改变您授权同意的范围**

每个业务功能需要一些基本的个人信息才能得以完成。对于额外的个人信息的收集和使用，您可以随时在智能手机上进行设置。

如果您不想接受我们给您发送的商业广告，您随时可以退订。
	
4. **个人信息主体注销账户**
	
您随时可注销此前注册的账户，您可以在Medcursor App“设置”中操作。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，在合理的期限内删除您的个人信息，法律法规另有规定的除外。
	
5. **响应您的上述请求**
	
为保障安全，**您可能需要提供书面请求，或以其他方式证明您的身份**。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在三十天内作出答复。如您不满意，还可以通过以下途径投诉: [support@medcursor.com](support@medcursor.com)。
	
对于您合理的请求，我们**原则上不收取费用**，但对多次重复或超出合理限度的请求，我们将视情形收取一-定成本费用。对于那些无端重复、需要过多技术手段(例如，需要 开发新系统或从根本上改变现行惯例)、给他人合法权益带来风险或者难以操作的请求，我们可能会予以拒绝。
	
**在以下情形中，我们将无法响应您的请求**:
	
● 与个人信息控制者履行法律法规规定的义务相关的;
	
● 与国家安全、 国防安全直接相关的;
	
● 与公共安全、公共卫生、重大公共利益直接相关的;
	
● 与刑事侦查、起诉、审判和执行判决等直接相关的;
	
● 个人信息控制者有充分证据表明个人信息主体存在主，观恶意或滥用权利的;
	
● 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;
	
● 响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的;
	
● 涉及商业秘密的。
	
### 六、我们如何处理儿童的个人数据
		
我们将不向儿童(即不满14周岁的未成年人)提供产品和服务。未经父母或监护人的同意，儿童不应创建自己的个人信息主体账户，不应使用我们的产品及服务。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
	
如父母或监护人有理由相信儿童未经其事先同意而向 Medcursor App提供了个人信息，请与我们联系以确保删除个人信息。
	
### 七、第三方提供商及其服务
		
**我们的隐私政策不适用于第三方提供的产品和服务**。我们的产品和服务可能包括第三方产品，服务以及指向第三方网站的链接。当您使用此类产品或服务时，他们可能会收集您的信息。因此，**我们强烈建议您认真阅读并理解该第三方的隐私政策。我们不对第三方如何使用他们向您收集的个人信息负责，也不能控制其使用。我们的隐私政策不适用通过我们的服务链接的其他网站**。
	
### 八、您的个人数据如何在全球范围转移
		
我们将尽量确保在中华人民共和国境内收集和产生的个人信息存储在中华人民共和国境内，但由于我们将通过遍布全球的资源和服务器提供产品或服务，这意味着，您同意您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问，并受到当地的相关法律及数据安全法的约束。
	
### 九、本政策如何更新
		
我们的隐私政策将不定时更新并在本页面上发布对本政策所做的任何变更。如**发生重大变更，我们还会提供更为显著的通知(比如，我们可能会通过电子邮件发送通知，或在用户使用时弹窗通知等方式说明隐私政策的具体变更内容**)。我们建议您定期查阅本网页获取我们隐私政策的最新信息。您继续使用产品和网站、手机和/或其他任何设备上的服务，将被视为接受更新的隐私政策。
	
### 十、如何联系我们
		
如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系:
	
公司名称: 深圳市远睿信息科技有限公司
	
公司地址: 2160 巴兰卡大道 #1092 欧文, CA 92606

Email: [support@medcursor.com](mailto:support@medcursor.com)
	


























































`;
export const privacyEN = ``